import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';
import {
  Announcement as AnnouncementIcon,
  Inbox as InboxIcon,
  Search as SearchIcon,
  Folder as FolderIcon
} from '@mui/icons-material';
const getIcon = (iconType) => {
  const iconProps = { sx: { fontSize: 48, color: '#9ca3af', mb: 2 } };
  switch (iconType) {
    case 'announcement':
      return <AnnouncementIcon {...iconProps} />;
    case 'inbox':
      return <InboxIcon {...iconProps} />;
    case 'search':
      return <SearchIcon {...iconProps} />;
    case 'folder':
      return <FolderIcon {...iconProps} />;
    default:
      return <InboxIcon {...iconProps} />;
  }
};
const EmptyState = ({ title, description, icon = 'inbox' }) => {
  return (
    <Box sx={{ 
      textAlign: 'center', 
      py: 8,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '200px'
    }}>
      {getIcon(icon)}
      <Typography variant="h6" sx={{ color: '#6b7280', mb: 1, fontWeight: 500 }}>
        {title}
      </Typography>
      <Typography variant="body2" sx={{ color: '#9ca3af', maxWidth: '300px' }}>
        {description}
      </Typography>
    </Box>
  );
};
EmptyState.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  icon: PropTypes.oneOf(['announcement', 'inbox', 'search', 'folder'])
};
export default EmptyState; 